import { render, staticRenderFns } from "./TherapistSearchTable.vue?vue&type=template&id=82bbc1a8&"
import script from "./TherapistSearchTable.vue?vue&type=script&lang=js&"
export * from "./TherapistSearchTable.vue?vue&type=script&lang=js&"
import style0 from "./TherapistSearchTable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports